import React, { useState } from 'react';
import {
  Create,
  CreateProps,
  FormTab,
  SaveButton,
  TabbedForm,
  Toolbar,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
  Notification,
} from 'react-admin';
import DreamHomeGeneral from './GeneralDreamHome';
import { useSelector } from 'react-redux';
import { TicketRatesDiscount } from '../../types/property';
import DreamHomeDescription from './DescriptionDreamHome';
import DiscountAndTickets from '../common/discount/DiscountTickets';
import {
  checkCreditsDateError,
  checkDateError,
  checkDiscount,
  checkDiscountFill,
  checkGeneralError,
  checkPreviousValue,
  checkTourLink,
} from '../../helpers/checkDreamHome';
import Button from '@material-ui/core/Button';
import { checkFillDiscount, checkIsCash } from '../../helpers/checkDiscount';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import { GeneralTabErrors } from '../../types/tabsError';
import { CreditProps } from '../common/generalPickersBlocks/credits/CreditsPickerComponent';
import {
  compilePropertyRequest,
  CompileRaffleRequest,
} from '../../helpers/compileDreamHome';
import { Overview } from './shared/overview/OverviewBlock';
import { checkIsOverviewPropRowValid } from './shared/overview/PropertyRow';
import { checkTicketsBundlesError } from '../../helpers/checkfFreeTickets';
import { OverviewProvider } from './shared/overview/OverviewContext';

const CustomToolbar = (
  props,
  handleImagesError,
  discountFillError,
  generalForm,
  setCheckGeneralError,
  setIsDiscountValidate,
  overview,
  setOverviewError,
  creditsData: {
    creditsArr: Array<CreditProps>;
    dateType: string;
    creditsStatus: boolean;
    creditsStartDate: Date | string | undefined;
    creditsEndDate: Date | string | undefined;
  }
): JSX.Element => {
  const location = props.location.pathname.split('/');
  const path = location[location.length - 1] === '1' ? '3' : '1';
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const stateApp = useSelector((state) => state);
  const dataProvider = useDataProvider();

  const cancel = () => {
    window.location.href = '/';
  };
  const handleSave = async (data): Promise<void> => {
    generalForm.adressFill = stateApp.property.adress;
    generalForm.imagesFill = stateApp.property.galleryFiles;
    generalForm.emailGalleryImage = stateApp.property.emailGalleryImage;
    const { generalResult, generalResultError } =
      checkGeneralError(generalForm);
    if (generalResultError) {
      console.table(generalResult);
      console.log(generalResultError);
      notify('The form in not valid. Please check for errors', 'error');
      setCheckGeneralError(generalResult);
      return;
    }

    // if (!checkIsOverviewPropRowValid(overview)) {
    //   setOverviewError(true);
    //   notify("The form is not valid. Please check for errors", "error");
    //   return;
    // }
    if (location[location.length - 1] === '1') {
      redirect(`/dreamHome/create/3`);
      return;
    }
    if (location[location.length - 1] === '3') {
      if (!data.ticketPrice || !data.defaultTickets) {
        setIsDiscountValidate(true);
        notify('The form in not valid. Please check for errors', 'error');
        return;
      }
    }
    data.stepperCountdown = {
      isActive: false,
      title: '',
      startAt: '',
      endsAt: '',
    };
    data.property.longitude = stateApp.property.longitude;
    data.property.latitude = stateApp.property.latitude;
    data.property.location = stateApp.property.adress;
    data.discountRates = data.isDiscountRates
      ? stateApp.property.discountRates
      : Array<TicketRatesDiscount>();
    data.property.filesGallery = stateApp.property.galleryFiles;
    data.property.filesGalleryMobile = stateApp.property.galleryFilesMobile;
    data.property.discountRates = stateApp.property.discountRates;
    data.discountTicket = stateApp.property.ticketDiscount;
    data.startAt = generalForm.startDateFill;
    data.endsAt = generalForm.endDateFill;
    data.stepperCountdown.isActive = generalForm.stepperIsActive
      ? generalForm.stepperIsActive
      : false;
    data.stepperCountdown.title = generalForm.stepperTitle
      ? generalForm.stepperTitle
      : '';
    data.stepperCountdown.startAt = generalForm.stepperStartDateFill;
    data.stepperCountdown.endsAt = generalForm.stepperEndDateFill;
    data.title = generalForm.title;
    data.creditsRates = creditsData.creditsArr;
    data.endDate = creditsData.creditsEndDate;
    data.startDate = creditsData.creditsStartDate;
    data.creditsStatus = creditsData.creditsStatus;
    data.isPermanent = creditsData.dateType === 'allDate' ? true : false;
    data.freeTicketsRates = stateApp.property.freeTickets.freeTicketsRates;
    data.isFreeTicketsRates = stateApp.property.freeTickets.isActive;
    data.ticketsBundles = stateApp.property.ticketsBounds.bundleTickets;
    if (!data.property.filesGallery.length) {
      handleImagesError(true);
      notify('The form is not valid. Please check for errors', 'error');
      return;
    }
    if (!data.title) {
      notify('The form is not valid. Please check for errors', 'error');
      return;
    }
    // if (!data.property.location) {
    //   notify('The form is not valid. Please check for errors', 'error');
    //   return;
    // }
    const discountFill = checkDiscountFill(data);
    if (discountFill) {
      discountFillError(true);
    }

    const checkDiscountTickets = checkFillDiscount(
      data.isActiveDiscount,
      data.discountTicket
    );
    const previousTicketCount = checkPreviousValue(data);
    const checkError = checkDiscount(data);
    const checkDate = checkDateError(data);
    const checkCreditsDate = data.isCreditsPermanent
      ? false
      : checkCreditsDateError(data);
    const ticketsBundlesError = checkTicketsBundlesError(data.ticketsBundles);
    if (
      !checkError ||
      checkDate ||
      discountFill ||
      !previousTicketCount ||
      checkCreditsDate ||
      checkDiscountTickets ||
      checkCreditsDate ||
      ticketsBundlesError
    ) {
      notify('The form is not valid. Please check for errors', 'error');
      return;
    }
    data.property.tourLink = checkTourLink(data.property.tourLink);
    const requestProperty = compilePropertyRequest(data.property, overview);
    let response = await dataProvider.createProperty(
      requestProperty.property,
      requestProperty.images
    );
    const reverseDiscount = checkIsCash(
      data.discountCategory,
      data.discountRates
    );
    const requestRaffle = CompileRaffleRequest(
      data,
      response.id,
      reverseDiscount
    );
    try {
      const result = (await dataProvider.create('raffles', {
        data: requestRaffle,
      })) as any;
      if (result.data.isTrending && result.data.active) {
        await dataProvider.addFeatured('DREAMHOME', result.data._id);
      }

      if (result.data._id) {
        notify(`Dream home saved`);
        refresh();
        redirect('/dreamHome');
      } else {
        notify(`Something went wrong`);
      }
    } catch (error: any) {
      notify(error, 'error');
    }
  };

  const toNextTab = () => {
    generalForm.adressFill = stateApp.property.adress;
    generalForm.imagesFill = stateApp.property.galleryFiles;
    generalForm.emailGalleryImage = stateApp.property.emailGalleryImage;
    const { generalResult, generalResultError } =
      checkGeneralError(generalForm);
    if (generalResultError) {
      notify('The form in not valid. Please check for errors', 'error');
      setCheckGeneralError(generalResult);
      return;
    }
    // if (path === "3") {
    //   if (!checkIsOverviewPropRowValid(overview)) {
    //     setOverviewError(true);
    //     notify("The form is not valid. Please check for errors", "error");
    //     return;
    //   }
    // }

    redirect(`/dreamHome/create/${path}`);
  };
  return (
    <Toolbar {...props} className='buttons-wrapper'>
      {location[location.length - 1] === '1' ||
      location[location.length - 1] === '3' ? (
        <SaveButton onSave={handleSave} className='save-button' />
      ) : (
        <>
          <Button className='cancel-button' onClick={toNextTab}>
            Save
          </Button>
        </>
      )}
      <Button onClick={cancel} className='cancel-button'>
        Cancel
      </Button>
    </Toolbar>
  );
};

const CreateDreamHome: React.FC<CreateProps> = (props) => {
  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date('2031-01-18T19:55:00.000+00:00'),
  });
  const [creditDateType, setCreditDateType] = useState<string>('allDate');
  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };

  const [stateCredits, setCredits] = useState<Array<CreditProps>>([
    {
      id: '1',
      count: 20,
      percent: 30,
    },
  ]);

  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };

  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };
  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  const [state, setState] = useState({
    adress: '',
    isCash: false,
    isPercent: false,
  });

  const [errors, setError] = useState({
    imagesError: false,
    discountFillError: false,
  });

  const [generallError, setGeneralError] = useState<GeneralTabErrors>({
    imagesError: false,
    adressError: false,
    startDateError: false,
    titleError: false,
    endDateError: false,
  });

  const [generalForm, setGeneralForm] = useState({
    titleFill: '',
    startDateFill: '',
    endDateFill: '',
    stepperIsActive: false,
    stepperStartDateFill: '',
    stepperEndDateFill: '',
    stepperTitle: '',
    title: '',
  });

  const [overview, setOverview] = useState<Array<Overview>>();

  const [overviewError, setOverviewError] = useState(false);

  const [isDiscountValidate, setIsDiscountValidate] = useState(false);

  const fillGeneralForm = (name: string, value: string) => {
    setGeneralForm({ ...generalForm, [name]: value });
  };

  const handleDiscountFillError = (error: boolean) => {
    setError({ ...errors, discountFillError: error });
  };

  const handleImagesError = (error: boolean) => {
    setError({ ...errors, imagesError: error });
  };

  const setAddress = (adress: string) => {
    setState({ ...state, adress: adress });
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };
  return (
    <>
      <DocumentTitle
        core='Prize'
        secondary='Dream Home'
        purpose='Add new'
        appointment='dream home'
      />
      <Create {...props}>
        <TabbedForm
          toolbar={CustomToolbar(
            props,
            handleImagesError,
            handleDiscountFillError,
            generalForm,
            setGeneralError,
            setIsDiscountValidate,
            overview,
            setOverviewError,
            {
              creditsArr: stateCredits,
              dateType: creditDateType,
              creditsStartDate: datesValue.startDateValue,
              creditsEndDate: datesValue.endDateValue,
              creditsStatus: isActiveCredits,
            }
          )}
          className='general-tab'
        >
          <FormTab label='General'>
            <DreamHomeGeneral
              imagesError={errors.imagesError}
              adress={state.adress || ''}
              latitude={0}
              longitude={0}
              record={undefined}
              isShow={false}
              setAddress={setAddress}
              fillGeneralForm={fillGeneralForm}
              generalError={generallError}
            />
          </FormTab>
          <FormTab label='Description'>
            <OverviewProvider prizeType='dreamhome'>
              <DreamHomeDescription
                key={generalForm.title}
                title={generalForm.title}
                record={undefined}
                setProperties={setOverview}
                properties={overview || []}
                isShow={false}
                setAddress={setAddress}
                overviewError={overviewError}
              />
            </OverviewProvider>
          </FormTab>
          <Notification />
          <FormTab label='Discount & Tickets'>
            <DiscountAndTickets
              entity={undefined}
              isShow={false}
              isCash={state.isCash}
              isPercent={state.isPercent}
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountSource='discountCategory'
              ticketPrice={0}
              discountFillError={errors.discountFillError}
              isOdds={false}
              isValidate={isDiscountValidate}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              competition='raffle'
            />
          </FormTab>
        </TabbedForm>
      </Create>
    </>
  );
};

export default CreateDreamHome;
